import React from 'react';
import {
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from 'web-library';
import { Dialog } from '@mui/material';

interface MandatorySingpassLoginModalProps {
  isOpen: boolean;
  onHavingSingpass: () => void;
  error: string | null;
}

const MandatorySingpassLoginModal = ({
  isOpen,
  onHavingSingpass,
  error,
}: MandatorySingpassLoginModalProps) => (
  <Dialog open={isOpen} maxWidth="md">
    <DialogTitle>You have a Singpass Account</DialogTitle>

    <DialogContent>
      <DialogContentText>Please use your Singpass for account creation.</DialogContentText>
    </DialogContent>

    <DialogActions>
      <Button variant="contained" color="secondary" type="button" onClick={onHavingSingpass}>
        Login with Singpass
      </Button>
    </DialogActions>
    <Typography align="center" color="error" variant="body2">
      {error}
    </Typography>
  </Dialog>
);

export default MandatorySingpassLoginModal;
